export default __webpack_public_path__ + "static/media/CLYBYMATTHEW_20221125PV_0007_MR1_3578.5c9de682.jpg";